import styles from "./styles.module.css";

interface FactoidItemProps {
  heading: string;
  blurb: string;
}

export default function FactoidItem({ heading, blurb }: FactoidItemProps) {
  return (
    <div className="md:text-center flex-grow basis-1/4 md:border-r-4 border-yellow-500 md:last:border-0 md:-skew-x-12">
      <div className="md:hidden border-t-4 w-1/4 border-yellow-500"></div>
      <div className="md:px-12 md:skew-x-12 mb-5">
        <h3 className="text-primary elm-h5 mt-3.5 md:-md-1 mb-2 md:mb-2.5">
          {heading}
        </h3>
        <span
          className={`mb-4 md:mb-0 ${styles.textbase}`}
          dangerouslySetInnerHTML={{ __html: blurb }}
        />
      </div>
    </div>
  );
}
